import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { slabSearchApi } from 'src/api/InsuranceSlabApi';

const SlabDropDown = ({ value, name, onChange, whereConditions, ...rest }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Slab"
        displayKeyPath={[
            'slabCode',
            'fuelType',
            'RTOLocation',
            'ncbValue',
            'slabRate',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={['slabCode']}
        whereConditions={whereConditions}
        api={slabSearchApi}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        onChange={onChange}
        {...rest}
    />
);

SlabDropDown.propTypes = {
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

SlabDropDown.defaultProps = {
    value: '',
    onChange: () => {},
};

export default SlabDropDown;
